import { cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { useIsMobile } from 'common/hooks/useIsMobile';
import { Heading2 } from 'common/typography/Typography';

import OnboardingPageHeader from './components/OnboardingPageHeader';

const Root = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  background-color: ${cssThemedValue('surfaceMain')};
  padding-block-end: ${({ isMobile }) => (isMobile ? 'max(32px, 7vw);' : 'min(40vw, 312px);')};
`;

const MerchantInfoHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  font-size: 18px;
`;

const ContentWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1000px;
  width: 100%;
  margin-block-start: 32px;
  padding-inline: ${({ isMobile }) => (isMobile ? '16px' : '0')};
`;

const OnboardingPage = () => {
  const isMobile = useIsMobile();

  /* 
    fetchDraftMerchantByUserId()
   */

  return (
    <Root isMobile={isMobile}>
      <OnboardingPageHeader />
      <MerchantInfoHeader>
        <Heading2>Megica Pizza</Heading2>
        Some str, 00010 Helsinki
      </MerchantInfoHeader>
      <ContentWrapper isMobile={isMobile}></ContentWrapper>
    </Root>
  );
};

export default OnboardingPage;
